import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
class TicketsSlider {
    constructor(el) {
        if (!this.set(el)) return;
        
        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' && !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.slider = this.root.querySelector('[data-tickets-slider-slider]');
        this.prevEl = this.root.querySelector('[data-tickets-slider-prev]');
        this.nextEl = this.root.querySelector('[data-tickets-slider-next]');

        return true;
    }

    init() {
        this.initSlider();
    }

    initSlider() {
        if (!this.slider) return;

        const swiperOptions = {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
        };

        if (this.nextEl && this.prevEl) {
            swiperOptions.navigation = {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
            };
        }

        this.swiper = new Swiper(this.slider, swiperOptions);
    }
}

const initTicketsSliders = () => {
    const sections = document.querySelectorAll('[data-tickets-slider]');
    if (sections) sections.forEach(item => new TicketsSlider(item));
};

initTicketsSliders();
